import {createContext} from 'react'
import {AnalyticsServicesController} from '../types/analyticsServicesTypes'

const AnalyticsV2Context = createContext<AnalyticsServicesController | undefined>(undefined)

export default AnalyticsV2Context
